import { createAsyncThunk } from "@reduxjs/toolkit";
import { homepage, deleteNotyNow } from "../../network/pagesNet";
import { getDeposit } from "../../network/userNet";
import {
  setNewBouquets,
  setNewCards,
  setNewSetting,
  setNewNews,
  setNewCategories,
  setNewSections,
  setDisplayMode,
} from "../slices/catalogSlice";
import {
  setNewNoty,
  setNewCountNoty,
  setNewAds,
} from "../slices/uiSlice";
import { setNewUser } from "../slices/authSlice";
import { setNewSales, setNewCrypto } from "../slices/walletSlice";

export const fetchHomepageData = createAsyncThunk(
  "pages/fetchHomepageData",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await homepage();
      if (response.data.success) {
        dispatch(setNewBouquets(response.data.data.bouquets));
        dispatch(setNewCards(response.data.data.cards));
        dispatch(setNewSales(response.data.data.sales));
        dispatch(setNewNews(response.data.data.news));
        dispatch(setNewSetting(response.data.data.settings));
        dispatch(setNewCategories(response.data.data.categories));
        dispatch(setNewSections(response.data.data.sections));
        dispatch(setDisplayMode(response.data.data.display_mode));
        dispatch(setNewUser(response.data.data.user));
        dispatch(setNewNoty(response.data.data.noty));
        dispatch(setNewCountNoty(response.data.data.countNoty));
        dispatch(setNewAds(response.data.Ads));
      }
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchDepositData = createAsyncThunk(
  "pages/fetchDepositData",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const response = await getDeposit();
      dispatch(setNewCrypto(response.data));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchNotifications = createAsyncThunk(
  "pages/fetchNotifications",
  async (_, { dispatch, rejectWithValue }) => {
    try {
      const { getNoty } = await import("../../network/pagesNet");
      const response = await getNoty();
      dispatch(setNewNoty(response.data.data.noty));
      dispatch(setNewCountNoty(response.data.data.countNoty));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const fetchNotificationsFiltered = createAsyncThunk(
  "pages/fetchNotificationsFiltered",
  async (filter, { dispatch, rejectWithValue }) => {
    try {
      const { getNotyFilter } = await import("../../network/pagesNet");
      const response = await getNotyFilter(filter);
      dispatch(setNewNoty(response.data.data.noty));
      dispatch(setNewCountNoty(response.data.data.countNoty));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);

export const deleteNotification = createAsyncThunk(
  "pages/deleteNotification",
  async (id, { dispatch, rejectWithValue }) => {
    try {
      const response = await deleteNotyNow(id);
      dispatch(setNewNoty(response.data.noty));
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
